<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">دوره‌های آموزشی</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 align-items-end">
        <div class="col-md-5">
          <label class="form-label fw-bold">نام دوره</label>
          <input
              type="text"
              class="form-control"
              placeholder="نام دوره را وارد کنید"
              v-model="newCourse.name"
          />
        </div>
        <div class="col-md-5">
          <label class="form-label fw-bold">نوع دوره</label>
          <select class="form-select" v-model="newCourse.type">
            <option value="" disabled>نوع دوره را انتخاب کنید</option>
            <option :value="type" v-for="(type, index) in types" :key="index">
              {{ type }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <GeneralButton @clicked="addCourse"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Courses Table -->
      <GeneralTable
          :headers="['نام دوره', 'نوع دوره']"
          :fields="['name', 'type']"
          :items="jobQualification.courses"
          :openEditModalMethod="openEditModal"
          @remove="removeCourse"
      />

      <!-- Edit Course Modal -->
      <GeneralModal
          v-show="editedCourse"
          title="ویرایش دوره آموزشی"
          modal-id="courseModalId"
          @save="updateCourse"
      >
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">نام دوره</label>
            <input
                type="text"
                class="form-control"
                placeholder="نام دوره را وارد کنید"
                v-if="editedCourse"
                v-model="editedCourse.name"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold">نوع دوره</label>
            <select class="form-select" v-if="editedCourse" v-model="editedCourse.type">
              <option value="" disabled>نوع دوره را انتخاب کنید</option>
              <option :value="type" v-for="(type, index) in types" :key="index">
                {{ type }}
              </option>
            </select>
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import {Modal} from 'bootstrap';
import {useToast} from "vue-toastification";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";

const baseStructure = {
  name: '',
  type: ''
}
const toast = useToast();

export default {
  components: {GeneralButton, GeneralTable, GeneralModal},
  data() {
    return {
      newCourse: structuredClone(baseStructure),
      types: ['عمومی', 'تخصصی'],
      editedCourse: null,
      editIndex: null,
    };
  },
  computed: {
    jobQualification: {
      get() {
        return this.$store.state.jobQualification.jobQualification;
      }
    },
  },
  methods: {
    async addCourse() {
      if (!this.newCourse.name || !this.newCourse.type) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newCourse,
        endpoint: '/job-qualifications/store-course',
      })

      this.jobQualification.courses = [...this.jobQualification.courses, structuredClone(response.data)];
      this.newCourse = structuredClone(baseStructure);
    },
    removeCourse(index) {
      const course = this.jobQualification.courses.find((_, i) => i === index);
      this.jobQualification.courses = this.jobQualification.courses.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: course.id,
        endpoint: '/job-qualifications/delete-course',
      })
    },
    openEditModal(course, index) {
      this.editedCourse = structuredClone(course);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('courseModalId'));
      modal.show();
    },
    updateCourse() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.editedCourse.name || !this.editedCourse.type) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      this.jobQualification.courses.splice(this.editIndex, 1, {...this.editedCourse});

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedCourse,
        endpoint: '/job-qualifications/update-course',
      })

      this.editIndex = null;
      this.editedCourse = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('courseModalId'));
      modal.hide();
    }
  }
};
</script>
